var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssistant = function SvgAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.937,
    height: 41.562,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Assistant_svg__a)",
    d: "m15.14 0 .44 1.511a17.52 17.52 0 0 0 9.357 10.957 17.52 17.52 0 0 0-9.357 10.957l-.44 1.511-.439-1.51a17.52 17.52 0 0 0-9.357-10.958A17.52 17.52 0 0 0 14.7 1.511z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Assistant_svg__b)",
    d: "m5.64 21.969.246.839a10.06 10.06 0 0 0 5.395 6.285 10.06 10.06 0 0 0-5.395 6.286l-.246.84-.245-.84A10.06 10.06 0 0 0 0 29.094a10.06 10.06 0 0 0 5.395-6.286z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Assistant_svg__c)",
    d: "m16.922 32.063.15.502a6.83 6.83 0 0 0 3.709 4.247 6.83 6.83 0 0 0-3.708 4.247l-.151.503-.151-.503a6.83 6.83 0 0 0-3.709-4.247 6.83 6.83 0 0 0 3.709-4.247z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Assistant_svg__a",
    x1: 20.151,
    x2: 27.515,
    y1: 4.943,
    y2: 26.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#7029CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F558C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Assistant_svg__b",
    x1: 8.572,
    x2: 14.91,
    y1: 19.108,
    y2: 37.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#7029CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F558C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Assistant_svg__c",
    x1: 18.756,
    x2: 23.941,
    y1: 23.703,
    y2: 38.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#7029CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F558C"
  })))));
};
export default SvgAssistant;